import { DateTime } from 'luxon'

import { City } from '@/model/City'
import { Snapshot } from '@/model/Snapshot'
import { TimeStepMaxFactory } from './TimeStepMaxFactory'
import { TimeStepCumulativeRainfall } from '@/model/TimeStepCumulativeRainfall'
import { TimeStepCumulativeRainfallFactory } from './TimeStepCumulativeRainfallFactory'
import { SnapshotCumulativeRainfallDTO } from '@/api/core/dto/snapshot/SnapshotCumulativeRainfallDTO'

export class SnapshotCumulativeRainfallFactory {
  static createEmpty(city: City, timestamp: DateTime): Snapshot<TimeStepCumulativeRainfall> {
    const result = new Snapshot<TimeStepCumulativeRainfall>(city, timestamp)
    result.setReference(TimeStepCumulativeRainfallFactory.createEmpty(result, timestamp))
    return result
  }

  static fromDTO(dto: SnapshotCumulativeRainfallDTO, city: City): Snapshot<TimeStepCumulativeRainfall> {
    const result = new Snapshot<TimeStepCumulativeRainfall>(city, DateTime.fromISO(dto.timestamp, { zone: 'UTC' }))

    for (const timeStepDTO of dto.history.filter((d) => d.cumulativeTimeAndIntensity)) {
      result.addHistory(TimeStepCumulativeRainfallFactory.fromDTO(timeStepDTO, result))
    }

    result.setReference(TimeStepCumulativeRainfallFactory.fromDTO(dto.reference, result))

    for (const timeStepDTO of dto.forecasts.filter((d) => d.cumulativeTimeAndIntensity)) {
      result.addForecast(TimeStepCumulativeRainfallFactory.fromDTO(timeStepDTO, result))
    }

    result.setMax(TimeStepMaxFactory.createEmpty(result, result.timestamp))

    return result
  }
}
